import _slicedToArray from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

/**
 * Takes a list of class names and filters for truthy ones, joining them into a single class name for convenience.
 * eg.
 * ```js
 *  cx('red', isBig && 'big') // returns 'red big' if `isBig` is true, otherwise returns 'red'
 * ```
 * If space separated atomic styles are provided, they are deduplicated according to the first hashed valued:
 *
 * ```js
 *  cx('atm_a_class1 atm_b_class2', 'atm_a_class3') // returns `atm_a_class3 atm_b_class2`
 * ```
 *
 * @returns the combined, space separated class names that can be applied directly to the class attribute
 */
var cx = function cx() {
  var presentClassNames = Array.prototype.slice // eslint-disable-next-line prefer-rest-params
  .call(arguments).filter(Boolean);
  var atomicClasses = {};
  var nonAtomicClasses = [];
  presentClassNames.forEach(function (arg) {
    // className could be the output of a previous cx call, so split by ' ' first
    var individualClassNames = arg ? arg.split(' ') : [];
    individualClassNames.forEach(function (className) {
      if (className.startsWith('atm_')) {
        var _className$split = className.split('_'),
            _className$split2 = _slicedToArray(_className$split, 2),
            keyHash = _className$split2[1];

        atomicClasses[keyHash] = className;
      } else {
        nonAtomicClasses.push(className);
      }
    });
  });
  var result = []; // eslint-disable-next-line no-restricted-syntax

  for (var keyHash in atomicClasses) {
    if (Object.prototype.hasOwnProperty.call(atomicClasses, keyHash)) {
      result.push(atomicClasses[keyHash]);
    }
  }

  result.push.apply(result, nonAtomicClasses);
  return result.join(' ');
};

export default cx;